import React, { useEffect, useState } from 'react';

import axios from 'axios';

import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import 'moment/locale/ko';
import Box from '@mui/material/Box';
import { useForm } from 'react-hook-form';
import Pagination from '@mui/material/Pagination';
import Container from '@mui/material/Container';

const columns = [
  { id: 'rowNumber', label: 'No', minWidth: 40, align: 'center' },
  { id: 'activeCode', label: '활성화 코드', minWidth: 140, align: 'center' },
  { id: 'issueSite', label: '발급처', minWidth: 100, align: 'center' },
  { id: 'comment', label: '사유', minWidth: 100, align: 'center' },
  { id: 'createdAt', label: '등록일', minWidth: 180, align: 'center' }
];

export default function MailMng() {
  const [rows, setRows] = useState([]);
  const [datas, setDatas] = useState({});
  const [pageCnt, setPageCnt] = useState(1);
  const [page, setPage] = useState(1);
  const [offset] = useState(10);

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    reset,
    formState: { errors, isDirty }
  } = useForm({
    mode: 'all'
  });

  const handleChange = (e) => {
    setDatas({ ...datas, [e.target.id]: e.target.value });
  };

  const handleRowClick = (data) => (evt) => {
    initForm();
    setDatas(data);
    setValue('datas', data);
  };

  const getDataList = async (e) => {
    let params = {
      offset,
      page,
      limit: offset
    };

    const response = await axios.get(`/api/active/disable`, { params });
    console.log(response);
    if (response.data) {
      const result = response.data.rows;
      setRows(result);
    }
  };

  const onClickInit = (evt) => {
    initForm();
  };

  const initForm = () => {
    setDatas({});
    clearErrors();
    reset();
  };

  const mailMngCreate = async (data) => {
    return await axios.post(`/api/active/disable`, data);
  };

  const onClickDelete = async (evt) => {
    try {
      if (datas.id) {
        await axios
          .delete(`/api/active/disable`, { params: datas })
          .then((response) => {
            getDataList();
            initForm();
            alert(response.data.message);
          })
          .catch((error) => {
            alert(error.response.data.message);
          });
      }
    } catch (e) {
      console.log(`insert failed`);
    }
  };

  const onSubmit = (data) => {
    if (isDirty) {
      mailMngCreate(datas)
        .then((response) => {
          getDataList();
          initForm();
          alert(response.data.message);
        })
        .catch((error) => {
          alert(error.response.data.message);
        });
    }
  };

  const handleChangePage = (event, value) => {
    setPage(value);
  };

  useEffect(() => {
    getDataList();
  }, []);

  return (
    <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
      <Typography component="h2" variant="h6" color="primary" gutterBottom>
        활성화 코드 차단 관리
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={9}>
          <TableContainer component={'div'}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell key={column.id} align={column.align} sx={{ minWidth: column.minWidth }}>
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, rowIdx) => (
                  <TableRow hover key={row.id} onClick={handleRowClick(row)}>
                    {columns.map((col, colIdx) => {
                      if (col.id === 'issueSite') {
                        let issueSite = 'DIDAS';
                        if (row.ActiveCodeMng) {
                          issueSite = 'DAC';
                        }
                        return (
                          <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                            {issueSite}
                          </TableCell>
                        );
                      } else {
                        return (
                          <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                            {row[col.id]}
                          </TableCell>
                        );
                      }
                    })}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <Container maxWidth="sm" sx={{ mt: 2 }}>
              <Pagination count={pageCnt} page={page} onChange={handleChangePage} showFirstButton showLastButton />
            </Container>
          </TableContainer>
        </Grid>
        <Grid item xs={3}>
          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <Button variant="contained" onClick={onClickInit}>
              초기화
            </Button>
            <Button variant="contained" type="submit" form="mailMngForm" disabled={isDirty ? false : true}>
              등록
            </Button>
            <Button variant="contained" onClick={onClickDelete} disabled={datas.id ? false : true}>
              삭제
            </Button>
          </Stack>
          <Box id="mailMngForm" component="form" onSubmit={handleSubmit(onSubmit)} noValidate sx={{ mt: 1, minWidth: 300, maxWidth: 500 }}>
            <TextField
              margin="dense"
              required
              fullWidth
              name="activeCode"
              label="활성화코드"
              id="activeCode"
              disabled={datas.id}
              value={datas?.activeCode || ''}
              error={!!errors.activeCode}
              {...register('activeCode', {
                required: '활성화 코드를 입력해주세요.',
                onChange: (e) => handleChange(e)
              })}
            />
            <TextField
              margin="dense"
              required
              fullWidth
              name="comment"
              label="사유"
              id="comment"
              disabled={datas.id}
              value={datas?.comment || ''}
              error={!!errors.comment}
              {...register('comment', {
                required: '사유를 입력해주세요.',
                onChange: (e) => handleChange(e)
              })}
            />
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
}
